import React from "react";
import { Row, Col } from "reactstrap";

import SalesGrowthChart from "./SalesGrowthChart";
import TopNetworksCard from "./TopNetworksCard";
import UsersComparisonChart from "./UsersComparisonChart";

const DashboardCharts = ({ selectedCountry,province,city }) => {

    // mb-4 iguala el aire que deja arriba la fila de tarjetas (que lo pone con
    // mb-4 en cada columna). Sin esto el salto hacia la fila de abajo quedaba
    // más apretado que el de arriba y el ritmo vertical se veía desparejo.
    return (
        <Row className="g-4 align-items-stretch mb-4">
            <Col xl="4" className="d-flex">
                <SalesGrowthChart selectedCountry={selectedCountry} province={province} city={city} />
            </Col>
            <Col xl="4" className="d-flex">
                <TopNetworksCard province={province} city={city} />
            </Col>

            <Col xl="4" className="d-flex">
                <UsersComparisonChart province={province} city={city} />
            </Col>
        </Row>

    );

};

export default DashboardCharts;